import { DSCircularButton } from "@components/design-system/molecules";
import { useStartCompanionChat } from "@hooks/use-start-companion-chat";
import { useFlags } from "launchdarkly-react-client-sdk";

import Twemoji from "../../../Twemoji";

export default function GatedQuillButton() {
  const { allowCompanionOptIn } = useFlags();
  const { startChat, isStarting } = useStartCompanionChat();

  if (!allowCompanionOptIn) return null;

  return (
    <DSCircularButton
      size="sm"
      disabled={isStarting}
      onClick={() => {
        if (isStarting) return;
        startChat();
      }}
      title="Edit with Quill"
      dataTestId="edit-with-quill-trigger"
    >
      <Twemoji className="text-xl z-20" emoji="🦔" />
    </DSCircularButton>
  );
}
